import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';

@Component({
  selector: 'app-sdk-payment-success',
  standalone: true,
  imports: [],
  templateUrl: './sdk-payment-success.component.html',
  styleUrls: ['../../../../auth.scss'],
})
export class SdkPaymentSuccessComponent implements AfterViewInit {
  @ViewChild('confetti') confettiContainer!: ElementRef;
  userId: string | null = null;
  sessionId: string | null = null;
  paymentVerified = false;
  paymentFailed = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PagesService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.userId =
      urlParams.get('user_id') ||
      urlParams.get('userId') ||
      this.route.snapshot.paramMap.get('user_id');
    this.sessionId = urlParams.get('session_id') || urlParams.get('sessionId');
  }

  ngAfterViewInit(): void {
    this.checkSdkPayment(this.userId, this.sessionId);
  }

  goToHomepage() {
    this.router.navigate(['/']);
    this.sharedService.hideLoader();
  }

  initializeConfetti() {
    setTimeout(() => {
      const container = this.confettiContainer?.nativeElement;
      if (!container) return;

      const totalPieces = 500;
      for (let i = 0; i < totalPieces; i++) {
        const confetti = document.createElement('div');
        confetti.classList.add('confetti-piece');
        confetti.style.left = Math.random() * 100 + 'vw';
        confetti.style.top = Math.random() * 10 + 'px';
        confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 70%, 60%)`;
        const size = Math.random() * 8 + 4;
        confetti.style.width = `${size}px`;
        confetti.style.height = `${size}px`;
        confetti.style.animationDelay = Math.random() * 2 + 's';
        confetti.style.animationDuration = (Math.random() * 2 + 3) + 's';
        confetti.addEventListener('animationend', () => confetti.remove());
        container.appendChild(confetti);
      }
    }, 100);
  }

  checkSdkPayment(user_id: string | null, session_id: string | null) {
    this.sharedService.showLoader();
    const payload = {
      user_id: user_id ? Number(user_id) : 0,
      session_id: session_id || '',
    };

    this.pageService.update('CHECK_SDK_PAYMENT', payload).subscribe({
      next: (response: any) => {
        if (response.data.isSuccess && response.data.status == 'paid') {
          this.paymentVerified = true;
          this.sharedService.createNotification('success', 'Your payment has been successful');
          this.sharedService.hideLoader();
          this.initializeConfetti();
        } else {
          this.paymentFailed = true;
          this.sharedService.createNotification('error', 'Issue in payment');
          this.sharedService.hideLoader();
        }
      },
      error: (err) => {
        this.paymentFailed = true;
        this.sharedService.createNotification('error', err.message || err || 'Issue in payment');
        this.sharedService.hideLoader();
      },
    });
  }
}
